import Button from "@mui/material/Button";
import { ButtonGroup, IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";

const BootstrapButton = styled(Button)(({ theme }) => ({}));

export const VerticalCounter = (props) => {
  const { value, onIncrease, onDecrease } = props;
  return (
    <ButtonGroup
      orientation="vertical"
      aria-label="vertical outlined button group"
      sx={{ width: "55px" }}
    >
      <IconButton onClick={() => onIncrease()}>
        <KeyboardArrowUpIcon />
      </IconButton>
      <BootstrapButton disabled>{value}</BootstrapButton>
      <IconButton onClick={() => onDecrease()}>
        <KeyboardArrowDownIcon />
      </IconButton>
    </ButtonGroup>
  );
};
//11/9/2022, 4:58:29 PM
